'use client';

var INTERNATION_PHONE_NUMBER_END_POINT = 'meta/v1.0/international-phone-number';
var VNW_NEW_REGISTERED = 'VNW_NEW_REGISTERED';
var initFormData = {
    firstName: '',
    lastName: '',
    jobTitle: '',
    jobLevelId: 0,
    highestDegreeId: 0,
    yearsExperience: 0,
    currentIndustries: [],
    currentJobFunction: 0,
    currentSalary: 0,
    email: '',
    phone: '',
    birthday: '',
    skills: [],
    genderId: 0,
    countryId: 0,
    cityId: 0,
    address: '',
    nationalityId: 0,
    maritalStatusId: 0,
    districtId: 0,
    isSearchable: 0,
    locations: [],
    industries: [],
    companyIndustries: [],
    isRelocate: 0,
    desiredJobLevelId: 0,
    salary: 0,
    benefits: []
};
var INTERNSHIP_ID = 8;
var FRESHER_ID = 1;
var INTERNATIONAL_CITY_ID = 70;
var MEKONG_CITY_ID = 71;
var OTHER_CITY_ID = 66;
var VIETNAM_COUNTRY_ID = 1;
var notAllowCityId = [INTERNATIONAL_CITY_ID, MEKONG_CITY_ID, OTHER_CITY_ID];
var SEARCH_DELAY_TIME = 1000;
var CLICK_DELAY_TIME = 500;
var DEFAULT_MIN_SALARY = 0;
var DEFAULT_MAX_SALARY = 500000;
var TODAY = new Date();
var MAX_DATE = new Date(TODAY.getFullYear(), TODAY.getMonth(), TODAY.getDate(), 23, 59, 59); // yyyy/mm/dd-23:59:59
var EMaritalStatus;
(function (EMaritalStatus) {
    EMaritalStatus[EMaritalStatus["NEW"] = 0] = "NEW";
    EMaritalStatus[EMaritalStatus["SINGLE"] = 1] = "SINGLE";
    EMaritalStatus[EMaritalStatus["MARRIED"] = 2] = "MARRIED";
})(EMaritalStatus || (EMaritalStatus = {}));
var EGender;
(function (EGender) {
    EGender[EGender["MALE"] = 1] = "MALE";
    EGender[EGender["FEMALE"] = 2] = "FEMALE";
})(EGender || (EGender = {}));
var nationalityList = function (langCode) {
    var nationalityList = {
        en: [
            { id: 1, name: 'Local Vietnamese' },
            { id: 2, name: 'Foreigner' }
        ],
        vi: [
            { id: 1, name: 'Người Việt Nam' },
            { id: 2, name: 'Người nước ngoài' }
        ]
    };
    return nationalityList["".concat(langCode)];
};
var educations = [
    { id: 2, name: 'Trung học', nameEn: 'High school' },
    { id: 3, name: 'Trung cấp', nameEn: "Associate's degree" },
    { id: 12, name: 'Cao đẳng', nameEn: 'College' },
    { id: 4, name: 'Cử nhân', nameEn: 'Bachelors' },
    { id: 5, name: 'Thạc sĩ', nameEn: 'Doctorate' },
    { id: 6, name: 'Tiến sĩ', nameEn: 'Others' },
    { id: 11, name: 'Khác', nameEn: 'Others' }
];

export { CLICK_DELAY_TIME, DEFAULT_MAX_SALARY, DEFAULT_MIN_SALARY, EGender, EMaritalStatus, FRESHER_ID, INTERNATIONAL_CITY_ID, INTERNATION_PHONE_NUMBER_END_POINT, INTERNSHIP_ID, MAX_DATE, MEKONG_CITY_ID, OTHER_CITY_ID, SEARCH_DELAY_TIME, VIETNAM_COUNTRY_ID, VNW_NEW_REGISTERED, educations, initFormData, nationalityList, notAllowCityId };
//# sourceMappingURL=const.js.map
